var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({class:{
    'fallback-image': !_vm.url,
    'grey-bg': !_vm.url && _vm.greyBg,
    'is-small': _vm.isPlaceholderSmall
  },attrs:{"src":_vm.url || (_vm.isPlaceholderSmall ? _vm.NO_IMAGE_SMALL : _vm.NO_IMAGE)}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }